// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import {
  addToArray,
  updateArrayItemByKey,
  removeArrayItemByKey,
  upsertByKey,
  removeByKey,
} from '../utils/utils';

// Script Lines
export const addScriptLineState = (state, line) => {
  addToArray(state.scripts.lines, line);
};

export const updateScriptLineState = (state, line) => {
  state.scripts.lines = updateArrayItemByKey(state.scripts.lines, 'line_uuid', line);
};

export const deleteScriptLineState = (state, lineUuid) => {
  state.scripts.lines = removeArrayItemByKey(state.scripts.lines, 'line_uuid', lineUuid);
};

// Script Subjects
export const addScriptSubjectState = (state, subject) => {
  upsertByKey(state.scripts.subjects, subject.subject_uuid, subject);
};

export const updateScriptSubjectState = (state, subject) => {
  if (!state.scripts.subjects[subject.subject_uuid]) {
    return;
  }
  upsertByKey(state.scripts.subjects, subject.subject_uuid, subject);
};

export const deleteScriptSubjectState = (state, subjectUuid) => {
  removeByKey(state.scripts.subjects, subjectUuid);
};

// Script Locations
export const addScriptLocationState = (state, location) => {
  upsertByKey(state.scripts.locations, location.location_uuid, location);
};

export const updateScriptLocationState = (state, location) => {
  if (!state.scripts.locations[location.location_uuid]) {
    return;
  }
  upsertByKey(state.scripts.locations, location.location_uuid, location);
};

export const deleteScriptLocationState = (state, locationUuid) => {
  removeByKey(state.scripts.locations, locationUuid);
};
